import { IDapiRequest } from "@origin-digital/daxi";
import {
  getCategories,
  getCategoryArticles,
  ICategoryDto,
  ICategoryWithArticlesDataDto,
} from "../../contract";
import { config } from "../../config";

const fetchCategories = async (): Promise<ICategoryDto[]> => {
  const FETCH_OPTIONS: IDapiRequest = {
    method: "GET",
  };

  const response = await getCategories(
    config.apiBasePath,
    FETCH_OPTIONS.authorization
  );

  return response?.data?.categories || [];
};

const fetchCategoryArticles = async (
  slug: string
): Promise<ICategoryWithArticlesDataDto> => {
  if (!slug) {
    throw new Error("Category slug is required");
  }

  const FETCH_OPTIONS: IDapiRequest = {
    method: "GET",
  };

  const response = await getCategoryArticles(
    config.apiBasePath,
    { id: slug },
    FETCH_OPTIONS.authorization
  );

  return response?.data;
};

export { fetchCategories, fetchCategoryArticles };
